import styled from "styled-components";
const ListVariantStyle = styled.div`
  @import url("https://fonts.googleapis.com/css2?family=Roboto+Slab:wght@500&display=swap");
  
  /* Contenedor del buscador fijo */
  .search-container {
    position: sticky;
    top: 0;
    z-index: 100;
    background: linear-gradient(135deg, #014788 0%, #764ba2 100%);
    padding: 12px;
    margin: -20px -20px 20px -20px;
    border-radius: 0 0 20px 20px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);
  }
  
  /* Estilos para el buscador */
  .input-group {
    border-radius: 18px;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    border: 2px solid rgba(255, 255, 255, 0.3);
    transition: all 0.3s ease;
  }
  
  .input-group:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 35px rgba(0, 0, 0, 0.2);
  }
  
  .input-group:focus-within {
    transform: translateY(-2px);
    box-shadow: 0 12px 35px rgba(0, 0, 0, 0.25);
    border-color: rgba(255, 255, 255, 0.8);
  }

  
  .search-input {
    border: none;
    border-left: none;
    padding: 20px;
    font-size: 15px;
    background: transparent;
    color: #333;
    font-weight: 500;
    letter-spacing: 0.5px;
  }
  
  .search-input::placeholder {
    color: #999;
    font-style: italic;
    font-weight: 400;
  }
  
  .search-input:focus {
    border: none;
    box-shadow: none;
    background: rgba(255, 255, 255, 0.98);
  }
  
  .clear-button {
    background: linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%);
    border: none;
    color: white;
    padding: 12px 18px;
    border-radius: 0 25px 25px 0;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 14px;
  }
  
  .clear-button:hover {
    background: linear-gradient(135deg, #ff5252 0%, #e64a19 100%);
    transform: scale(1.05);
    box-shadow: 0 4px 15px rgba(238, 90, 36, 0.4);
  }
  
  /* Información de resultados */
  .results-info {
    text-align: center;
    margin-top: 15px;
  }
  
  .results-count {
    background: rgba(255, 255, 255, 0.9);
    color: #014788;
    padding: 8px 20px;
    border-radius: 20px;
    font-weight: 600;
    font-size: 14px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.3);
  }
  
  .list-variant {
    background-color: white;
    border: 1px solid #e5e9f2;
    border-radius: 0.85rem;
    visibility: visible;
    direction: inherit;
    box-sizing: border-box !important;
    position: relative;
    display: block;
    min-width: 100%;
    max-width: 100%;
    width: 100%;
    height: 100%;
    max-height: 500px;
    // ${({maxHeight}) => maxHeight && `min-height: ${maxHeight};`}
    // ${({minHeight}) => minHeight && `max-height: ${minHeight};`}
    // ${({height}) => height && `height: ${height};`}
    overflow-y: auto;
    overflow-x: hidden;
    
    /* width */
    ::-webkit-scrollbar {
      width: 12px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: linear-gradient(180deg, #f8f9fa 0%, #e9ecef 100%);
      border-radius: 10px;
      border: 1px solid #dee2e6;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: linear-gradient(180deg, #014788 0%, #764ba2 100%);
      border-radius: 10px;
      min-height: 50px;
      border: 2px solid #f8f9fa;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: linear-gradient(180deg, #5a6fd8 0%, #6a4190 100%);
      box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
    }
    
    /* Firefox scrollbar */
    scrollbar-width: thin;
    scrollbar-color: #014788 #f8f9fa;
  }
  
  .nv {
    color: rgb(94, 84, 142);
  }
  .dv {
    color: gray;
  }
  .nv,
  .dv {
    margin-bottom: 0.2rem;
    font-size: 10pt;
    font-family: "Roboto Slab", serif !important;
  }
  
  .imgVariant {
    min-width: 120px !important;
    width: 120px !important;
    max-width: 120px !important;
    border-radius: 15px !important;
    transition: all 0.3s ease;
    border: 2px solid transparent;
    background: #ddddddb5;
  }
  
  .imgVariant:hover {
    transform: translateY(-5px) scale(1.05);
    box-shadow: 0 15px 35px rgba(102, 126, 234, 0.3);
    border-color: transparent;
    background: #dddddd;
  }
  
  /* Estado seleccionado */
  .imgVariant.selected {
    border: 2px solid #014788 !important;
    box-shadow: 0 8px 25px #014788 !important;
    transform: scale(1.05);
    position: relative;
  }
  
  .imgVariant.selected::after {
    content: "✓";
    position: absolute;
    top: -8px;
    right: -8px;
    background: #014788;
    color: white;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: bold;
    box-shadow: 0 2px 8px #014788;
  }
  
  .imgVariant.selected:hover {
    transform: translateY(-5px) scale(1.08);
    box-shadow: 0 15px 35px #014788 !important;
  }
  
  /* Responsive design */
  @media (max-width: 768px) {
    .search-container {
      padding: 15px;
      margin: -15px -15px 15px -15px;
    }
    
    .input-group {
      border-radius: 20px;
    }
    
    .clear-button {
      padding: 10px 15px;
      font-size: 14px;
    }
    
    .search-input {
      padding: 10px 15px;
      font-size: 14px;
    }
    
    .results-count {
      padding: 6px 15px;
      font-size: 12px;
    }
  }
`;
export default ListVariantStyle;
